var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.52399 3.06974C10.0895 3.06974 10.548 2.61128 10.548 2.04575C10.548 1.48022 10.0895 1.02177 9.52399 1.02177C8.95845 1.02177 8.5 1.48022 8.5 2.04575C8.5 2.61128 8.95845 3.06974 9.52399 3.06974Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5722 1.63863C12.0247 1.63863 12.3916 1.27181 12.3916 0.819315C12.3916 0.36682 12.0247 0 11.5722 0C11.1198 0 10.7529 0.36682 10.7529 0.819315C10.7529 1.27181 11.1198 1.63863 11.5722 1.63863Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0132 13.9784L10.7528 7.16632V5.12056H11.9818V3.68692H5.01791V5.12056H6.24688V7.16632L1.98651 13.9784C1.83031 14.268 1.74097 14.5991 1.74097 14.9517C1.74097 16.0828 2.65787 17 3.78926 17H13.2107C14.3418 17 15.259 16.0831 15.259 14.9517C15.259 14.5991 15.1697 14.268 15.0132 13.9784ZM5.24793 11.4672L7.68053 7.57756V5.12025H9.31916V7.57756L11.7518 11.4672H5.24793Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipment);
export default __webpack_public_path__ + "static/media/Equipment.b9b5ba41.svg";
export { ForwardRef as ReactComponent };